/* Metabolica Health Inc. — hero & global enhancements
   Drop-in single file. Idempotent: safe to re-run.
   Respects prefers-reduced-motion. */
/* Locale-aware path helper. Prepends window.MH_LOCALE_ROOT (set by
   layout/theme.liquid from routes.root_url) so internal URLs created in
   client-side megamenus stay on the current locale (/fr/...) instead of
   snapping back to English. Pass-through for absolute URLs, anchors, etc. */
window.mhLocalizePath = function (path) {
  if (!path) return path;
  if (path.indexOf('://') !== -1) return path;
  if (path.charAt(0) === '#') return path;
  if (path.indexOf('mailto:') === 0) return path;
  if (path.indexOf('tel:') === 0) return path;
  if (path.indexOf('javascript:') === 0) return path;
  var root = (typeof window.MH_LOCALE_ROOT === 'string') ? window.MH_LOCALE_ROOT : '/';
  if (root === '/' || !root) return path;
  if (path.charAt(0) !== '/') return path;
  if (path === root) return path;
  if (path.indexOf(root + '/') === 0) return path;
  return root + path;
};
(() => {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Treat narrow / coarse-pointer viewports as mobile — skip particles,
  // skip cursor-tracking gradients, etc. Battery + GPU savings, and
  // hover-only effects don't translate to touch anyway.
  const MOBILE = window.matchMedia('(max-width: 820px), (pointer: coarse)').matches;

  const STYLE_ID = 'mh-anim-styles';
  document.getElementById(STYLE_ID)?.remove();
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    /* Headline split wrappers exist for layout only — no entrance animation. */
    .hero-home h1.display .mh-line { display:inline-block; }
    .hero-home h1.display .mh-word { display:inline-block; }
    .hero-home .eyebrow, .hero-home .lede, .hero-home .ctas, .hero-home .hero-chips {
      opacity:0; transform:translateY(14px);
      transition: opacity .8s ease-out, transform .8s ease-out;
    }
    .hero-home .eyebrow.is-in, .hero-home .lede.is-in, .hero-home .ctas.is-in, .hero-home .hero-chips.is-in {
      opacity:1; transform:none;
    }

    /* Particles canvas (don't promote .hero-home children to position:relative) */
    .mh-particles {
      position:absolute; inset:0; pointer-events:none; z-index:0;
      mix-blend-mode:multiply; opacity:.55;
    }
    .hero-home .wrap, .hero-home .mh-scroll-cue { position:relative; z-index:1; }

    /* Trust strip */
    .hero-home .meta-strip { margin-bottom: 56px; }
    .hero-home .meta-strip span {
      opacity:0; transform:translateY(8px); position:relative;
      transition: opacity .7s ease-out, transform .7s ease-out;
    }
    .hero-home .meta-strip span.is-in { opacity:1; transform:none; }
    .hero-home .meta-strip span::before {
      content:""; display:inline-block; width:8px; height:8px;
      border-radius:50%; background:currentColor; opacity:1;
      margin-right:10px; transform:translateY(-2px);
      box-shadow:0 0 0 0 currentColor;
      animation: mh-dot-breathe 2.2s ease-in-out infinite;
    }
    .hero-home .meta-strip span:nth-child(1)::before { animation-delay:0s; }
    .hero-home .meta-strip span:nth-child(2)::before { animation-delay:.4s; }
    .hero-home .meta-strip span:nth-child(3)::before { animation-delay:.8s; }
    .hero-home .meta-strip span:nth-child(4)::before { animation-delay:1.2s; }
    @keyframes mh-dot-breathe {
      0%,100% {
        transform: translateY(-2px) scale(.9);
        box-shadow: 0 0 0 0 rgba(15,30,80,.45);
        opacity: .55;
      }
      50% {
        transform: translateY(-2px) scale(1.25);
        box-shadow: 0 0 0 6px rgba(15,30,80,0);
        opacity: 1;
      }
    }

    /* Scroll cue — lifted higher off the viewport edge and given a
       stronger pill so it doesn't disappear against busy hero imagery. */
    .mh-scroll-cue {
      position:absolute; left:50%; bottom:8px; transform:translateX(-50%);
      display:inline-flex; align-items:center; gap:12px;
      padding:10px 18px 10px 20px;
      font-size:12px; font-weight:600; letter-spacing:.18em; text-transform:uppercase;
      color:rgba(15,30,80,.92);
      background:rgba(255,255,255,.78);
      border:1px solid rgba(15,30,80,.12);
      border-radius:999px;
      backdrop-filter: blur(10px) saturate(160%);
      -webkit-backdrop-filter: blur(10px) saturate(160%);
      box-shadow: 0 10px 28px -12px rgba(15,30,80,.35), inset 0 1px 0 0 rgba(255,255,255,.55);
      opacity:0; transition:opacity .9s ease-out;
      z-index:2; pointer-events:none;
    }
    .mh-scroll-cue.is-in { opacity:1; animation: mh-cue-float 3.2s ease-in-out 2.4s infinite; }
    .mh-scroll-cue svg.mh-chev {
      width:14px; height:18px; flex-shrink:0;
      animation: mh-arrow-bob 2.0s ease-in-out infinite;
    }
    @keyframes mh-arrow-bob {
      0%,100% { transform: translateY(0);   opacity:.7; }
      50%     { transform: translateY(5px); opacity:1;   }
    }
    @keyframes mh-cue-float {
      0%,100% { transform: translateX(-50%) translateY(0); }
      50%     { transform: translateX(-50%) translateY(-3px); }
    }
    @media (max-width:640px){
      .mh-scroll-cue { bottom:12px; padding:8px 14px 8px 16px; font-size:11px; }
    }

    /* CTA hover */
    .hero-home .ctas .btn {
      transition: transform .25s ease, box-shadow .25s ease, background-color .25s ease;
    }
    .hero-home .ctas .btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 14px 36px -14px rgba(15,30,80,.45);
    }
    .hero-home .ctas .btn.ghost:hover,
    .hero-home .ctas .btn.secondary:hover {
      box-shadow: 0 10px 26px -14px rgba(15,30,80,.35);
    }

    /* Resilio launch */
    .resilio-launch {
      position:relative; overflow:hidden;
      --cx:50%; --cy:50%;
      background:
        radial-gradient(60% 60% at calc(var(--cx)*.4 + 20%) calc(var(--cy)*.4 + 15%),
          #f5b69a 0%, rgba(245,182,154,0) 60%),
        radial-gradient(55% 55% at calc(var(--cx)*.5 + 60%) calc(var(--cy)*.5 + 30%),
          #e88aa6 0%, rgba(232,138,166,0) 60%),
        radial-gradient(70% 70% at calc(var(--cx)*.3 + 30%) calc(var(--cy)*.3 + 70%),
          #8a6cc4 0%, rgba(138,108,196,0) 65%),
        linear-gradient(135deg, #b87560 0%, #9a4d75 45%, #3d2f78 100%);
      background-size: 180% 180%, 200% 200%, 220% 220%, 100% 100%;
      animation: mh-grad-drift 22s ease-in-out infinite alternate;
    }
    @keyframes mh-grad-drift {
      0%   { background-position: 0% 0%, 100% 0%, 50% 100%, 0 0; }
      50%  { background-position: 40% 30%, 60% 40%, 30% 60%, 0 0; }
      100% { background-position: 20% 60%, 80% 20%, 70% 30%, 0 0; }
    }
    .resilio-launch .mh-accent-dots { position:absolute; inset:0; pointer-events:none; z-index:0; }
    .resilio-launch > *:not(.mh-accent-dots) { position:relative; z-index:1; }
    .resilio-launch .btn {
      position:relative; overflow:hidden;
      transition: transform .25s ease, box-shadow .25s ease;
    }
    .resilio-launch .btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 16px 36px -14px rgba(40,10,60,.45);
    }
    .resilio-launch .btn .mh-ripple {
      position:absolute; border-radius:50%; background:rgba(255,255,255,.55);
      pointer-events:none; transform:translate(-50%,-50%) scale(0); opacity:.7;
      animation: mh-ripple 650ms ease-out forwards;
    }
    @keyframes mh-ripple { to { transform:translate(-50%,-50%) scale(18); opacity:0; } }

    /* Pill header — glassy lives entirely on the wrap. The wrap spans
       the full viewport width at rest so the glassy bar reaches the
       edges of the page, but its left/right padding is calc'd to keep
       the content (logo, links, util) centered inside the original
       1224px content area. On scroll, max-width clamps to 1180px and
       padding collapses to 22px, morphing the bar into a centered pill. */
    #shopify-section-header { position:sticky; top:0; z-index:100; }
    #shopify-section-header .wrap {
      max-width: 100vw;
      padding-left: max(48px, calc((100vw - 1224px) / 2));
      padding-right: max(48px, calc((100vw - 1224px) / 2));
      background: rgba(255,255,255,.65);
      -webkit-backdrop-filter: saturate(160%) blur(14px);
      backdrop-filter: saturate(160%) blur(14px);
      border: 1px solid rgba(255,255,255,.55);
      border-radius: 0;
      box-shadow:
        inset 0 1px 0 0 rgba(255,255,255,.55),
        0 8px 24px -16px rgba(15,30,80,.18);
      transition: max-width .4s cubic-bezier(.22,.61,.36,1),
                  padding .4s cubic-bezier(.22,.61,.36,1),
                  border-radius .4s cubic-bezier(.22,.61,.36,1),
                  box-shadow .4s ease;
    }
    body.mh-scrolled #shopify-section-header .nav { padding:10px 0 !important; }
    body.mh-scrolled #shopify-section-header .wrap {
      max-width:1180px;
      margin:0 auto;
      padding:10px 22px;
      border-radius:999px;
      box-shadow:
        inset 0 1px 0 0 rgba(255,255,255,.55),
        0 18px 40px -18px rgba(15,30,80,.22),
        0 2px 6px 0 rgba(15,30,80,.06);
    }

    /* Header utility hover pills (EN/FR · Account · Cart) */
    #shopify-section-header .util .lang,
    #shopify-section-header .util a {
      padding:6px 14px; border-radius:999px;
      border:1px solid transparent;
      text-decoration:none; display:inline-flex; align-items:center; line-height:1;
      transition: background-color .25s ease, border-color .25s ease,
                  box-shadow .25s ease, transform .25s ease, color .25s ease;
    }
    #shopify-section-header .util .lang { border-color: rgba(15,30,80,.18); }
    #shopify-section-header .util .lang:hover,
    #shopify-section-header .util a:hover {
      background: rgba(255,255,255,.7);
      border-color: rgba(15,30,80,.12);
      box-shadow: 0 10px 26px -14px rgba(15,30,80,.35),
                  inset 0 1px 0 0 rgba(255,255,255,.6);
      transform: translateY(-1px);
    }
    body.mh-scrolled #shopify-section-header .util .lang:hover,
    body.mh-scrolled #shopify-section-header .util a:hover {
      background: rgba(255,255,255,.85);
    }

    /* Reduced motion */
    @media (prefers-reduced-motion: reduce) {
      .hero-home h1.display .mh-line,
      .hero-home h1.display .mh-word,
      .hero-home .eyebrow, .hero-home .lede, .hero-home .ctas, .hero-home .hero-chips,
      .hero-home .meta-strip span,
      .mh-scroll-cue { opacity:1 !important; transform:none !important; filter:none !important; transition-delay:0s !important; }
      .resilio-launch { animation:none !important; }
      .hero-home .meta-strip span::before,
      .mh-scroll-cue svg.mh-chev { animation:none !important; }
    }
  `;
  document.head.appendChild(style);

  /* Hero: split headline word-by-word + cascading reveal.
     Only slide 1's headline is split (querySelector matches the first h1).
     Each word gets an inline transition-delay so a single .is-in on the
     parent .mh-line triggers the staggered wave via CSS. */
  const hero = document.querySelector('.hero-home');
  if (hero) {
    const WORD_STAGGER_MS = 60;
    const h1 = hero.querySelector('h1.display');
    let wordCount = 0;
    if (h1 && !h1.dataset.mhSplit) {
      h1.dataset.mhSplit = '1';
      const groups = h1.querySelectorAll('p').length ? h1.querySelectorAll('p') : [h1];
      // Recursively walk a node tree, splitting text nodes into per-word
      // spans while preserving inline tags (em, strong, br, etc.).
      const wrapWords = (parent) => {
        Array.from(parent.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            if (!node.nodeValue.trim()) return;
            const frag = document.createDocumentFragment();
            node.nodeValue.split(/(\s+)/).forEach(part => {
              if (part === '') return;
              if (/^\s+$/.test(part)) {
                frag.appendChild(document.createTextNode(part));
              } else {
                const w = document.createElement('span');
                w.className = 'mh-word';
                w.style.transitionDelay = (wordCount * WORD_STAGGER_MS) + 'ms';
                w.textContent = part;
                wordCount++;
                frag.appendChild(w);
              }
            });
            node.parentNode.replaceChild(frag, node);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            wrapWords(node);
          }
        });
      };
      groups.forEach(g => {
        const line = document.createElement('span');
        line.className = 'mh-line';
        while (g.firstChild) line.appendChild(g.firstChild);
        g.appendChild(line);
        wrapWords(line);
      });
    }
    const reveal = (el, d=0) => el && setTimeout(() => el.classList.add('is-in'), d);
    const eyebrows = hero.querySelectorAll('.eyebrow');
    const ledes    = hero.querySelectorAll('.lede');
    const ctasAll  = hero.querySelectorAll('.ctas');
    const chipsAll = hero.querySelectorAll('.hero-chips');
    // Headline shows instantly (no word cascade). Trailing elements fade in
    // on a quick staggered timeline so they still feel intentional.
    eyebrows.forEach(el => reveal(el, 100));
    ledes.forEach(el => reveal(el, 260));
    chipsAll.forEach(el => reveal(el, 380));
    ctasAll.forEach(el => reveal(el, 500));
    hero.querySelectorAll('.meta-strip span').forEach((s,i) => reveal(s, 700 + i*120));

    if (!REDUCED && !MOBILE && !hero.querySelector('.mh-particles')) {
      const canvas = document.createElement('canvas');
      canvas.className = 'mh-particles';
      hero.appendChild(canvas);
      const ctx = canvas.getContext('2d');
      let w, h, dots;
      const N = 42;
      const resize = () => {
        const r = hero.getBoundingClientRect();
        canvas.width  = (w = r.width)  * devicePixelRatio;
        canvas.height = (h = r.height) * devicePixelRatio;
        canvas.style.width = w + 'px';
        canvas.style.height = h + 'px';
        ctx.setTransform(1,0,0,1,0,0);
        ctx.scale(devicePixelRatio, devicePixelRatio);
      };
      const init = () => {
        dots = Array.from({length:N}, () => ({
          x: Math.random()*w, y: Math.random()*h,
          r: 1 + Math.random()*2.4,
          vx: (Math.random()-.5)*.25, vy: (Math.random()-.5)*.25,
          a: .15 + Math.random()*.35,
        }));
      };
      const tick = () => {
        ctx.clearRect(0,0,w,h);
        dots.forEach(d => {
          d.x += d.vx; d.y += d.vy;
          if (d.x<0||d.x>w) d.vx*=-1;
          if (d.y<0||d.y>h) d.vy*=-1;
          ctx.beginPath();
          ctx.arc(d.x, d.y, d.r, 0, Math.PI*2);
          ctx.fillStyle = 'rgba(15,30,80,' + d.a + ')';
          ctx.fill();
        });
        requestAnimationFrame(tick);
      };
      resize(); init(); tick();
      window.addEventListener('resize', () => { resize(); init(); });
    }

    if (!hero.querySelector('.mh-scroll-cue')) {
      const cue = document.createElement('div');
      cue.className = 'mh-scroll-cue';
      cue.innerHTML =
        '<span>Scroll to explore</span>' +
        '<svg class="mh-chev" viewBox="0 0 14 18" fill="none" aria-hidden="true">' +
          '<path d="M7 1 V14 M2 10 L7 15 L12 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';
      hero.appendChild(cue);
      setTimeout(() => cue.classList.add('is-in'), 600);
    }
  }

  /* Resilio interactions */
  const resilio = document.querySelector('.resilio-launch');
  if (resilio) {
    if (!resilio.querySelector('.mh-accent-dots')) {
      const layer = document.createElement('div');
      layer.className = 'mh-accent-dots';
      for (let i = 0; i < 14; i++) {
        const d = document.createElement('span');
        const size = 2 + Math.random()*3;
        Object.assign(d.style, {
          position:'absolute',
          left:(Math.random()*100)+'%',
          top:(Math.random()*100)+'%',
          width:size+'px', height:size+'px',
          borderRadius:'50%',
          background:'rgba(255,255,255,.55)',
          filter:'blur(.4px)',
          opacity:(.35 + Math.random()*.35).toFixed(2),
          transform:'translate(-50%,-50%)',
        });
        layer.appendChild(d);
      }
      resilio.appendChild(layer);
    }

    if (!REDUCED && !MOBILE && !resilio.dataset.mhCursor) {
      resilio.dataset.mhCursor = '1';
      let tx=50, ty=50, ex=50, ey=50, raf=null;
      const apply = () => {
        ex += (tx-ex)*0.06; ey += (ty-ey)*0.06;
        resilio.style.setProperty('--cx', ex+'%');
        resilio.style.setProperty('--cy', ey+'%');
        if (Math.abs(tx-ex)>0.05 || Math.abs(ty-ey)>0.05) raf = requestAnimationFrame(apply);
        else raf = null;
      };
      const kick = () => { if (!raf) raf = requestAnimationFrame(apply); };
      resilio.addEventListener('mousemove', (e) => {
        const r = resilio.getBoundingClientRect();
        tx = ((e.clientX-r.left)/r.width)*100;
        ty = ((e.clientY-r.top)/r.height)*100;
        kick();
      });
      resilio.addEventListener('mouseleave', () => { tx=50; ty=50; kick(); });
    }

    resilio.querySelectorAll('.btn').forEach(btn => {
      if (btn.dataset.mhRipple) return;
      btn.dataset.mhRipple = '1';
      btn.addEventListener('click', (e) => {
        const r = btn.getBoundingClientRect();
        const dot = document.createElement('span');
        dot.className = 'mh-ripple';
        const size = Math.max(r.width, r.height)*0.6;
        Object.assign(dot.style, {
          left:(e.clientX-r.left)+'px',
          top:(e.clientY-r.top)+'px',
          width:size+'px', height:size+'px',
        });
        btn.appendChild(dot);
        setTimeout(() => dot.remove(), 700);
      });
    });
  }

  /* Sticky pill header state */
  const onScroll = () => {
    const y = window.scrollY || window.pageYOffset;
    document.body.classList.toggle('mh-scrolled', y > 60);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
/* ============================================================
   Hero carousel — left/right arrows + dots for the .hero-home
   slides. Same pattern as the press quote carousel below; kept
   separate so the two can be tuned independently. Idempotent.
   ============================================================ */
(() => {
  if (window.__mhHeroCarousel) return;
  const carousel = document.querySelector('.hero-carousel[data-multi]');
  if (!carousel) return;
  window.__mhHeroCarousel = true;

  const track = carousel.querySelector('.hero-carousel-track');
  const prev = carousel.querySelector('.hero-carousel-prev');
  const next = carousel.querySelector('.hero-carousel-next');
  const dots = Array.from(carousel.querySelectorAll('.hero-carousel-dot'));
  const realSlides = Array.from(carousel.querySelectorAll('.hero-slide'));
  if (!track || realSlides.length < 2) return;
  const bgLayers = Array.from(document.querySelectorAll('.hero-bg-layer'));
  const REAL_COUNT = realSlides.length;

  // True infinite scroll: clone the first slide and append it after
  // the last, and clone the last slide and prepend it before the first.
  // When the user scroll-snaps onto a clone, silently jump to the
  // matching real slide so they can keep scrolling forever in either
  // direction without hitting a hard boundary.
  const firstClone = realSlides[0].cloneNode(true);
  const lastClone  = realSlides[REAL_COUNT - 1].cloneNode(true);
  firstClone.setAttribute('aria-hidden', 'true');
  lastClone.setAttribute('aria-hidden', 'true');
  firstClone.dataset.clone = 'first';
  lastClone.dataset.clone  = 'last';
  // The intro animation captures element references before this clone
  // step runs, so cloned reveal-targets (.eyebrow/.lede/.ctas/.mh-line)
  // never get .is-in and would render at opacity:0. Mark them already-
  // revealed so the clone looks identical to the original instantly.
  [firstClone, lastClone].forEach(clone => {
    clone.querySelectorAll('.eyebrow, .lede, .ctas, .mh-line, .mh-word, .hero-chips').forEach(el => el.classList.add('is-in'));
    // Clear per-word stagger on clones so they don't replay the wave when
    // the carousel scrolls past them.
    clone.querySelectorAll('.mh-word').forEach(w => { w.style.transitionDelay = '0ms'; });
  });
  track.appendChild(firstClone);
  track.insertBefore(lastClone, realSlides[0]);

  const setScrollSilent = (left) => {
    const prevBehavior = track.style.scrollBehavior;
    const prevSnap     = track.style.scrollSnapType;
    track.style.scrollBehavior = 'auto';
    track.style.scrollSnapType = 'none';
    track.scrollLeft = left;
    requestAnimationFrame(() => {
      track.style.scrollSnapType = prevSnap || '';
      track.style.scrollBehavior = prevBehavior || '';
    });
  };

  // Park at real slide 0 (track index 1, after the leading clone)
  setScrollSilent(track.clientWidth);

  const trackIndex = () => {
    if (!track.clientWidth) return 1;
    return Math.round(track.scrollLeft / track.clientWidth);
  };
  const realIndex = () => {
    const idx = trackIndex();
    if (idx === 0) return REAL_COUNT - 1;
    if (idx === REAL_COUNT + 1) return 0;
    return idx - 1;
  };

  const goNext = () => track.scrollTo({ left: (trackIndex() + 1) * track.clientWidth, behavior: 'smooth' });
  const goPrev = () => track.scrollTo({ left: (trackIndex() - 1) * track.clientWidth, behavior: 'smooth' });
  const goToReal = (realIdx) => track.scrollTo({ left: (realIdx + 1) * track.clientWidth, behavior: 'smooth' });

  // If we just settled on a clone, silently jump to the matching real
  // slide. This is what turns the snap-bounded carousel into an
  // infinite loop.
  const handleClone = () => {
    const idx = trackIndex();
    if (idx === 0)                  setScrollSilent(REAL_COUNT * track.clientWidth);
    else if (idx === REAL_COUNT + 1) setScrollSilent(track.clientWidth);
  };

  const sync = () => {
    const idx = realIndex();
    dots.forEach((d, i) => {
      const active = i === idx;
      d.classList.toggle('is-active', active);
      if (active) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
    bgLayers.forEach(layer => {
      const layerIdx = parseInt(layer.dataset.slideBg, 10);
      layer.classList.toggle('is-active', layerIdx === idx);
    });
  };

  // Auto-rotate every 12s. Pauses when the tab is hidden, restarts on
  // manual interaction. Respects prefers-reduced-motion.
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const AUTO_DELAY = 20000;
  let autoTimer = null;
  const startAuto = () => {
    if (REDUCED) return;
    stopAuto();
    autoTimer = setInterval(goNext, AUTO_DELAY);
  };
  const stopAuto = () => {
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
  };

  if (prev) prev.addEventListener('click', () => { goPrev(); startAuto(); });
  if (next) next.addEventListener('click', () => { goNext(); startAuto(); });
  dots.forEach((d, i) => d.addEventListener('click', () => { goToReal(i); startAuto(); }));

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopAuto();
    else startAuto();
  });

  // Pause auto-rotate while the user is mid-scroll so the auto timer
  // doesn't fight their input. Resume 1s after they settle.
  let userScrollTimer;
  const onUserScroll = () => {
    stopAuto();
    clearTimeout(userScrollTimer);
    userScrollTimer = setTimeout(startAuto, 1000);
  };

  let raf;
  // Prefer the native scrollend event — fires the moment the scroll
  // truly stops, no debounce guess required. Falls back to a short
  // timeout for browsers that don't support it yet.
  const hasScrollend = 'onscrollend' in window;
  let settleTimer;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(sync);
    onUserScroll();
    if (!hasScrollend) {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(handleClone, 80);
    }
  }, { passive: true });
  if (hasScrollend) track.addEventListener('scrollend', handleClone);

  window.addEventListener('resize', () => {
    setScrollSilent((realIndex() + 1) * track.clientWidth);
    sync();
  });

  carousel.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft')  { e.preventDefault(); goPrev(); startAuto(); }
    if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); startAuto(); }
  });

  sync();
  startAuto();
})();

/* ============================================================
   Press quote carousel — wires the left/right arrows, dot
   indicators, and active-state tracking for the scroll-snap
   track in the .pull-quote section. Idempotent; safe to re-run.
   ============================================================ */
(() => {
  if (window.__mhPressCarousel) return;
  const carousel = document.querySelector('.pull-quote-carousel[data-multi]');
  if (!carousel) return;
  window.__mhPressCarousel = true;

  const track = carousel.querySelector('.pull-quote-track');
  const prev = carousel.querySelector('.pull-quote-prev');
  const next = carousel.querySelector('.pull-quote-next');
  const dots = Array.from(carousel.querySelectorAll('.pull-quote-dot'));
  const realSlides = Array.from(carousel.querySelectorAll('.pull-quote-slide'));
  if (!track || realSlides.length < 2) return;

  const REAL_COUNT = realSlides.length;

  // Same infinite-loop pattern as the hero carousel.
  const firstClone = realSlides[0].cloneNode(true);
  const lastClone  = realSlides[REAL_COUNT - 1].cloneNode(true);
  firstClone.setAttribute('aria-hidden', 'true');
  lastClone.setAttribute('aria-hidden', 'true');
  firstClone.dataset.clone = 'first';
  lastClone.dataset.clone  = 'last';
  track.appendChild(firstClone);
  track.insertBefore(lastClone, realSlides[0]);

  const setScrollSilent = (left) => {
    const prevBehavior = track.style.scrollBehavior;
    const prevSnap     = track.style.scrollSnapType;
    track.style.scrollBehavior = 'auto';
    track.style.scrollSnapType = 'none';
    track.scrollLeft = left;
    requestAnimationFrame(() => {
      track.style.scrollSnapType = prevSnap || '';
      track.style.scrollBehavior = prevBehavior || '';
    });
  };

  setScrollSilent(track.clientWidth);

  const trackIndex = () => {
    if (!track.clientWidth) return 1;
    return Math.round(track.scrollLeft / track.clientWidth);
  };
  const realIndex = () => {
    const idx = trackIndex();
    if (idx === 0) return REAL_COUNT - 1;
    if (idx === REAL_COUNT + 1) return 0;
    return idx - 1;
  };

  const goNext = () => track.scrollTo({ left: (trackIndex() + 1) * track.clientWidth, behavior: 'smooth' });
  const goPrev = () => track.scrollTo({ left: (trackIndex() - 1) * track.clientWidth, behavior: 'smooth' });
  const goToReal = (realIdx) => track.scrollTo({ left: (realIdx + 1) * track.clientWidth, behavior: 'smooth' });

  const handleClone = () => {
    const idx = trackIndex();
    if (idx === 0)                  setScrollSilent(REAL_COUNT * track.clientWidth);
    else if (idx === REAL_COUNT + 1) setScrollSilent(track.clientWidth);
  };

  const sync = () => {
    const idx = realIndex();
    dots.forEach((d, i) => {
      const active = i === idx;
      d.classList.toggle('is-active', active);
      if (active) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
    // Arrows are never disabled — the carousel wraps infinitely.
  };

  if (prev) prev.addEventListener('click', goPrev);
  if (next) next.addEventListener('click', goNext);
  dots.forEach((d, i) => d.addEventListener('click', () => goToReal(i)));

  let raf, settleTimer;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(sync);
    clearTimeout(settleTimer);
    settleTimer = setTimeout(handleClone, 160);
  }, { passive: true });

  window.addEventListener('resize', () => {
    setScrollSilent((realIndex() + 1) * track.clientWidth);
    sync();
  });

  carousel.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft')  { e.preventDefault(); goPrev(); }
    if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); }
  });

  sync();
})();

/* ============================================================
   Editorial carousel — simple prev/next scroll for the
   "From the Journal" article cards (no clone repetition).
   The clone-based "endless" variant runs only when the carousel
   is explicitly marked data-multi.
   ============================================================ */
(() => {
  if (window.__mhEditorialNav) return;
  const carousel = document.querySelector('.editorial-carousel:not([data-multi])');
  if (carousel) {
    window.__mhEditorialNav = true;
    const track = carousel.querySelector('.editorial-track');
    const prev = carousel.querySelector('.editorial-carousel-prev');
    const next = carousel.querySelector('.editorial-carousel-next');
    if (track && (prev || next)) {
      const cardStep = () => {
        const card = track.querySelector('.article-card');
        if (!card) return 320;
        const cs = getComputedStyle(track);
        const gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -cardStep(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: cardStep(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      update();
    }
  }
})();
(() => {
  if (window.__mhEditorialCarousel) return;
  const carousel = document.querySelector('.editorial-carousel[data-multi]');
  if (!carousel) return;
  window.__mhEditorialCarousel = true;

  const track = carousel.querySelector('.editorial-track');
  const prev = carousel.querySelector('.editorial-carousel-prev');
  const next = carousel.querySelector('.editorial-carousel-next');
  const realCards = Array.from(track.querySelectorAll('.article-card'));
  if (!track || realCards.length < 2) return;

  const REAL_COUNT = realCards.length;

  // True endless recycling: clone the ENTIRE set of real cards at both
  // ends. Layout becomes [leading-set, real-set, trailing-set]. The
  // silent-jump triggers as soon as the leftmost visible card lands in
  // a clone region — the equivalent position in the real set has the
  // same visible cards, so the swap is invisible. Result: the user can
  // scroll horizontally as long as they like and the same articles
  // cycle past without ever hitting a hard edge.
  realCards.forEach(card => {
    const clone = card.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.dataset.clone = 'trailing';
    track.appendChild(clone);
  });
  const leadingClones = realCards.map(card => {
    const clone = card.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.dataset.clone = 'leading';
    return clone;
  });
  for (let i = leadingClones.length - 1; i >= 0; i--) {
    track.insertBefore(leadingClones[i], track.firstChild);
  }

  const cardStep = () => {
    const card = realCards[0];
    const cs = getComputedStyle(track);
    const gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  };

  const setScrollSilent = (left) => {
    const prevBehavior = track.style.scrollBehavior;
    const prevSnap     = track.style.scrollSnapType;
    track.style.scrollBehavior = 'auto';
    track.style.scrollSnapType = 'none';
    track.scrollLeft = left;
    requestAnimationFrame(() => {
      track.style.scrollSnapType = prevSnap || '';
      track.style.scrollBehavior = prevBehavior || '';
    });
  };

  // Park at real card 0 (track position REAL_COUNT, after leading set)
  setScrollSilent(REAL_COUNT * cardStep());

  const trackIndex = () => {
    const step = cardStep();
    if (!step) return REAL_COUNT;
    return Math.round(track.scrollLeft / step);
  };

  const goNext = () => track.scrollTo({ left: (trackIndex() + 1) * cardStep(), behavior: 'smooth' });
  const goPrev = () => track.scrollTo({ left: (trackIndex() - 1) * cardStep(), behavior: 'smooth' });

  // Silent-jump: as soon as the leftmost-visible card is in a clone
  // region, swap to the equivalent real position. The set of cards
  // visible in the viewport is identical at both positions because
  // each clone is a duplicate of its real counterpart.
  const handleClone = () => {
    const idx = trackIndex();
    if (idx < REAL_COUNT) {
      setScrollSilent((idx + REAL_COUNT) * cardStep());
    } else if (idx >= REAL_COUNT * 2) {
      setScrollSilent((idx - REAL_COUNT) * cardStep());
    }
  };

  if (prev) prev.addEventListener('click', goPrev);
  if (next) next.addEventListener('click', goNext);

  const hasScrollend = 'onscrollend' in window;
  let settleTimer;
  track.addEventListener('scroll', () => {
    if (!hasScrollend) {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(handleClone, 80);
    }
  }, { passive: true });
  if (hasScrollend) track.addEventListener('scrollend', handleClone);

  window.addEventListener('resize', () => {
    // Re-park on the current real-equivalent card so widths recompute cleanly
    let idx = trackIndex();
    if (idx < REAL_COUNT) idx += REAL_COUNT;
    else if (idx >= REAL_COUNT * 2) idx -= REAL_COUNT;
    setScrollSilent(idx * cardStep());
  });

  carousel.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft')  { e.preventDefault(); goPrev(); }
    if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); }
  });
})();

/* ============================================================
   Scroll reveals — fades below-the-fold sections in as they
   enter the viewport. Section heads, copy blocks, and grid
   items get tagged with .mh-reveal; grid items get a stagger.
   Respects prefers-reduced-motion (skipped entirely).
   Idempotent: safe to re-run.
   ============================================================ */
(() => {
  if (window.__mhScrollReveal) return;
  window.__mhScrollReveal = true;

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const styleId = 'mh-reveal-styles';
  document.getElementById(styleId)?.remove();
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    .mh-reveal {
      opacity: 0;
      transform: translateY(28px);
      transition: opacity .9s cubic-bezier(.22,.61,.36,1),
                  transform .9s cubic-bezier(.22,.61,.36,1);
      will-change: opacity, transform;
    }
    .mh-reveal.is-in { opacity: 1; transform: none; }
    .mh-reveal[data-stagger="1"] { transition-delay: .08s; }
    .mh-reveal[data-stagger="2"] { transition-delay: .16s; }
    .mh-reveal[data-stagger="3"] { transition-delay: .24s; }
    .mh-reveal[data-stagger="4"] { transition-delay: .32s; }
    @media (prefers-reduced-motion: reduce) {
      .mh-reveal { opacity: 1 !important; transform: none !important; transition: none !important; }
    }
  `;
  document.head.appendChild(style);

  if (REDUCED || !('IntersectionObserver' in window)) return;

  const tag = (selector, staggered) => {
    document.querySelectorAll(selector).forEach((el, i) => {
      el.classList.add('mh-reveal');
      if (staggered) el.dataset.stagger = String(Math.min(i, 4));
    });
  };

  // Section-level reveals — whole blocks fade up as one beat
  tag('.resilio-launch .now');
  tag('.resilio-launch h2.display');
  tag('.resilio-launch .lede');
  tag('.resilio-launch .ctas');
  tag('.resilio-launch .product-row');
  tag('.pull-quote .eyebrow');
  tag('.pull-quote .pub-logo');
  tag('.pull-quote blockquote');
  tag('.pull-quote cite');
  tag('.pull-quote .pub-link');
  tag('.science-teaser .col-l');
  tag('.science-teaser .col-r');
  tag('.editorial .head');
  tag('.closing .eyebrow');
  tag('.closing h2.display');
  tag('.closing .chips');
  tag('.closing > .wrap > a.btn');

  // Philosophy + How We Do It — full-card variant (science page).
  // On the homepage these selectors find nothing because the markup uses
  // the condensed .home-philband structure below.
  tag('.philosophy .philosophy-head');
  tag('.philosophy .philosophy-closer');
  tag('.section-break .section-break__inner');
  tag('.how-we-do-it .how-col-text');
  tag('.how-we-do-it .how-figure');

  // Condensed homepage variant — Philosophy band + pillars + How-We-Do-It
  tag('.home-philband__head');
  tag('.home-how__text');
  tag('.home-how__figure');

  // PDP new sections (Why the gut? / What's inside / FAQ)
  tag('.pdp-why-gut__col-text');
  tag('.pdp-why-gut__figure');
  tag('.pdp-inside .head');
  tag('.pdp-faq-v2 .head');

  // About — new copy slots (principle line, RRA close, beliefs intro,
  // ACREOS callout, proof strip)
  tag('.ab-hero__principle');
  tag('.ab-hero__rra');
  tag('.ab-beliefs__intro');
  tag('.ab-acreos__col-l');
  tag('.ab-acreos__col-r');
  tag('.ab-acreos__status');
  tag('.ab-proof__head');
  tag('.ab-proof__footer');

  // Grid items get a staggered cascade
  tag('.editorial-grid > .article-card', true);
  tag('.philosophy-grid > .philosophy-card', true);
  tag('.home-pillars > .home-pillar', true);
  tag('.pdp-inside-list > li', true);
  tag('.ab-proof__cards > .ab-proof-card', true);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.mh-reveal').forEach(el => observer.observe(el));
})();

/* ============================================================
   Mega menu — hover on Shop reveals all products (Seed-style)
   ============================================================ */
(() => {
  // Read from window.MH_SHOP_PRODUCTS (injected by sections/header.liquid),
  // which pulls each product's featured_image via Liquid. Falls back to a
  // hardcoded list if the global isn't present.
  const PRODUCTS = (window.MH_SHOP_PRODUCTS && window.MH_SHOP_PRODUCTS.length) ? window.MH_SHOP_PRODUCTS : [
    { code: '01 · GUT-BRAIN',         title: 'Resilio™', desc: 'A 24h psychobiotic, for calm focus and restful sleep.',         handle: 'resilio', img: '' },
    { code: '02 · METABOLIC BALANCE', title: 'ReShape™',    desc: 'A daily ritual for improved health, weight, lipids & glucose.', handle: 'reshape',    img: '' },
    { code: '03 · STRESS & MOOD',     title: 'Lucid Calm™', desc: 'Delicious, focused and unbothered.',                            handle: 'lucid-calm', img: '' },
  ];

  // Styles
  const css = document.createElement('style');
  css.id = 'mh-mega-css';
  css.textContent = `
    .mh-megamenu {
      position: fixed; top: 60px; left: 50%;
      transform: translate(-50%, -10px);
      width: 420px; max-height: 78vh;
      padding: 14px;
      background: rgba(255,255,255,.65);
      -webkit-backdrop-filter: saturate(160%) blur(14px);
      backdrop-filter: saturate(160%) blur(14px);
      border: 1px solid rgba(255,255,255,.55);
      border-radius: 22px;
      box-shadow:
        inset 0 1px 0 0 rgba(255,255,255,.55),
        0 24px 60px -22px rgba(15,30,80,.30),
        0 4px 12px 0 rgba(15,30,80,.06);
      overflow: hidden auto;
      opacity: 0; pointer-events: none;
      transition: opacity .28s ease, transform .28s cubic-bezier(.22,.61,.36,1);
      z-index: 200;
      font-family: ui-sans-serif, system-ui, Arial, sans-serif;
    }
    .mh-megamenu.is-open { opacity: 1; transform: translate(-50%, 0); pointer-events: auto; }
    .mh-megamenu .mh-mega-item {
      display: flex; align-items: center; gap: 14px;
      padding: 10px 12px; border-radius: 14px;
      text-decoration: none; color: rgb(15,30,80);
      transition: background-color .2s ease, transform .2s ease;
    }
    .mh-megamenu .mh-mega-item:hover { background: rgba(255,255,255,.85); transform: translateX(2px); }
    .mh-megamenu .mh-mega-thumb {
      flex: 0 0 64px; width: 64px; height: 78px;
      border-radius: 10px;
      background: linear-gradient(135deg, rgba(220,230,242,.6), rgba(196,212,228,.6));
      background-size: cover; background-position: center;
      box-shadow: inset 0 0 0 1px rgba(15,30,80,.06);
    }
    .mh-megamenu .mh-mega-thumb--bundles {
      background: linear-gradient(135deg, rgba(248,184,136,.55) 0%, rgba(199,109,142,.45) 50%, rgba(106,96,160,.50) 100%);
      display: flex; align-items: center; justify-content: center;
      gap: 4px;
    }
    .mh-megamenu .mh-mega-thumb--bundles span {
      width: 10px; height: 10px; border-radius: 50%;
      background: rgba(255,255,255,.85);
      box-shadow: 0 1px 2px rgba(15,30,80,.18);
    }
    .mh-megamenu .mh-mega-meta { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
    .mh-megamenu .mh-mega-code {
      font-size: 11px; letter-spacing: .12em; text-transform: uppercase;
      color: rgba(15,30,80,.55);
    }
    .mh-megamenu .mh-mega-title {
      font-size: 16px; font-weight: 600; line-height: 1.2; color: rgb(15,30,80);
    }
    .mh-megamenu .mh-mega-desc {
      font-size: 12.5px; line-height: 1.4; color: rgba(15,30,80,.62);
      margin-top: 2px;
      display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
    }
    .mh-megamenu .mh-mega-divider { height: 1px; background: rgba(15,30,80,.08); margin: 8px 4px; }
    .mh-megamenu .mh-mega-all {
      display: flex; justify-content: center; align-items: center; gap: 6px;
      padding: 12px 16px; margin-top: 4px; border-radius: 14px;
      text-decoration: none; font-size: 14px; font-weight: 500; color: rgb(15,30,80);
      transition: background-color .2s ease;
    }
    .mh-megamenu .mh-mega-all:hover { background: rgba(15,30,80,.06); }
    .mh-megamenu .mh-mega-all .arr { display: inline-block; transition: transform .25s ease; }
    .mh-megamenu .mh-mega-all:hover .arr { transform: translateX(4px); }
  `;
  document.head.appendChild(css);

  // Build panel
  const panel = document.createElement('div');
  panel.className = 'mh-megamenu';
  panel.innerHTML =
    PRODUCTS.map(p => `
      <a class="mh-mega-item" href="${window.mhLocalizePath('/products/' + p.handle)}">
        <div class="mh-mega-thumb" style="${p.img ? `background-image:url('${p.img}')` : ''}"></div>
        <div class="mh-mega-meta">
          <span class="mh-mega-code">${p.code}</span>
          <span class="mh-mega-title">${p.title}</span>
          ${p.desc ? `<span class="mh-mega-desc">${p.desc}</span>` : ''}
        </div>
      </a>
    `).join('') +
    `<div class="mh-mega-divider"></div>` +
    `<a class="mh-mega-all" href="${window.mhLocalizePath('/pages/shop')}">${(window.MH_MEGAMENU_LABELS && window.MH_MEGAMENU_LABELS.shopViewAll) || 'View all products'} <span class="arr">→</span></a>`;
  document.body.appendChild(panel);

  // Find the megamenu trigger — matches by label OR by URL path so localized
  // labels (Discover → Découvrir, etc.) still attach the menu.
  const shop = Array.from(document.querySelectorAll('#shopify-section-header .links a'))
    .find(a => {
      const text = a.textContent.trim();
      const href = a.getAttribute('href') || '';
      return text === 'Discover' || text === 'Shop' ||
             href.indexOf('/collections/all') !== -1 ||
             href.indexOf('/pages/shop') !== -1;
    });
  if (!shop) return;

  const positionPanel = () => {
    const r = shop.getBoundingClientRect();
    panel.style.left = (r.left + r.width / 2) + 'px';
    panel.style.top  = (r.bottom + 32) + 'px';
  };

  let openTimer, closeTimer;
  const open  = () => { clearTimeout(closeTimer); openTimer  = setTimeout(() => { positionPanel(); panel.classList.add('is-open'); }, 80); };
  const close = () => { clearTimeout(openTimer);  closeTimer = setTimeout(() => panel.classList.remove('is-open'), 180); };

  shop.addEventListener('mouseenter', open);
  shop.addEventListener('mouseleave', close);
  panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
  panel.addEventListener('mouseleave', close);
  window.addEventListener('scroll', positionPanel, { passive: true });
  window.addEventListener('resize', positionPanel);

  // Click on Shop closes the hover panel and follows the link (Shop's href
  // in the header — typically /collections/all). The hover dropdown stays
  // as a passive discovery aid; clicking the word "Shop" always navigates.
  shop.addEventListener('click', () => {
    panel.classList.remove('is-open');
  });
})();
/* ============================================================
   SCIENCE PAGE — "View all publications" CTA
   Injects a button under the "What we're publishing" intro
   that links to /pages/publications
   ============================================================ */
(function(){
  if (window.__mhPubsCTA) return;
  window.__mhPubsCTA = true;

  function init(){
    const wrap = document.querySelector('.sci-pubs .wrap');
    if (!wrap) return;
    if (wrap.querySelector('.mh-pubs-cta')) return; // idempotent

    // Inject styles
    const style = document.createElement('style');
    style.textContent = `
      .mh-pubs-cta-row{
        margin: 22px 0 28px;
        display: flex;
      }
      .mh-pubs-cta{
        display: inline-flex; align-items: center; gap: 10px;
        padding: 14px 22px;
        border-radius: 999px;
        background: #0f1e50;
        color: #ffffff;
        font-size: 14px; font-weight: 600; letter-spacing: .01em;
        text-decoration: none;
        box-shadow: 0 8px 24px -10px rgba(15,30,80,.45);
        transition: transform .22s ease, box-shadow .22s ease, background .22s ease;
        will-change: transform;
      }
      .mh-pubs-cta:hover{
        background: #16266b;
        transform: translateY(-2px);
        box-shadow: 0 14px 32px -10px rgba(15,30,80,.55);
      }
      .mh-pubs-cta:active{ transform: translateY(0); }
      .mh-pubs-cta .arrow{
        display:inline-block;
        transition: transform .22s ease;
      }
      .mh-pubs-cta:hover .arrow{ transform: translateX(3px); }
      @media (prefers-reduced-motion: reduce){
        .mh-pubs-cta, .mh-pubs-cta .arrow{ transition: none; }
        .mh-pubs-cta:hover{ transform: none; }
        .mh-pubs-cta:hover .arrow{ transform: none; }
      }
    `;
    document.head.appendChild(style);

    // Build button row
    const row = document.createElement('div');
    row.className = 'mh-pubs-cta-row';
    // Pull translated label from MH_MEGAMENU_LABELS (set by layout/theme.liquid).
    // Strip trailing arrow because the span renders it separately for hover animation.
    const _PUBS_RAW = (window.MH_MEGAMENU_LABELS && window.MH_MEGAMENU_LABELS.scienceViewAll) || 'View all publications →';
    const _PUBS_TEXT = _PUBS_RAW.replace(/\s*→\s*$/, '');
    row.innerHTML = `
      <a class="mh-pubs-cta" href="${window.mhLocalizePath('/pages/publications')}">
        ${_PUBS_TEXT}
        <span class="arrow" aria-hidden="true">→</span>
      </a>
    `;

    // Place after the subhead paragraph (the "Updated quarterly..." line)
    const subhead = wrap.querySelector('p.body, p');
    if (subhead && subhead.parentNode === wrap) {
      subhead.insertAdjacentElement('afterend', row);
    } else {
      // fallback: append at the end of .wrap
      wrap.appendChild(row);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* The "SCIENCE PAGE — Dummy strain pictograms" IIFE was removed.
   It was injecting placeholder SVG icons (sun / moon / biome) and
   overwriting the strain card text with "[Strain name — AM]" etc.
   That overrode anything the section's Liquid rendered (videos, images,
   real strain text from blocks). Now that the section is populated with
   real videos and labels via blocks, the dummies are no longer needed. */
/* ============================================================
   SCIENCE PAGE — hide the "The people behind the work / Science"
   header section so the page starts with the Approach hero.
   Scoped to /pages/science only.
   ============================================================ */
(function(){
  if (window.__mhHideSciHeader) return;
  window.__mhHideSciHeader = true;

  if (!/^\/pages\/science\/?$/.test(location.pathname)) return;

  const css = `
    /* Hide the default page-template header block on /pages/science */
    #shopify-section-template--26663412367681__main { display: none !important; }
  `;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
})();
/* ============================================================
   SCIENCE PAGE — Approach hero: smaller scale + background video
   To set the video: upload an .mp4 to Shopify admin
   (Content → Files → Upload), copy its CDN URL, and paste it
   below as VIDEO_URL. Leave blank to keep the solid-navy bg.
   ============================================================ */
/* Science hero — video + styles are handled by sections/science.liquid
   and theme.css. The legacy JS injection that lived here was injecting
   `padding: 110px 48px 90px !important` on .sci-hero, which fought
   every CSS update. Removed Nov 2026. */
/* ============================================================
   Science mega menu — hover dropdown w/ thumbnails
   ============================================================ */
(function () {
  if (window.__mhSciMenuLoaded) return;
  window.__mhSciMenuLoaded = true;

  const sciLink = Array.from(document.querySelectorAll('header a, .nav a, .links a'))
    .find(a => {
      const text = (a.textContent || '').trim();
      const href = a.getAttribute('href') || '';
      return /^\s*science\s*$/i.test(text) || href.indexOf('/pages/science') !== -1;
    });
  if (!sciLink) return;

  // Pull the first 3 publications from window.MH_RECENT_PUBS (rendered by
  // layout/theme.liquid from the /pages/publications page content). Fall back
  // to a single "View publications" item if the array is empty.
  const PUBS = (Array.isArray(window.MH_RECENT_PUBS) && window.MH_RECENT_PUBS.length)
    ? window.MH_RECENT_PUBS.slice(0, 3)
    : [{ tag: '', title: 'View all publications', href: window.mhLocalizePath('/pages/publications') }];
  const STRAIN_PLACEHOLDER = 'linear-gradient(135deg, #1d3a8a 0%, #0b1f4d 100%)';
  // ================================================

  const css = `
    .mh-scimenu { position: fixed; z-index: 9999; min-width: 460px; max-width: 480px;
      padding: 14px; border-radius: 22px;
      background: rgba(255,255,255,.65);
      -webkit-backdrop-filter: saturate(1.6) blur(14px);
      backdrop-filter: saturate(1.6) blur(14px);
      border: 1.25px solid rgba(255,255,255,.55);
      box-shadow: 0 18px 48px rgba(8,18,40,.18), 0 2px 6px rgba(8,18,40,.08);
      opacity: 0; transform: translateY(-6px); pointer-events: none;
      transition: opacity .18s ease, transform .18s ease; }
    .mh-scimenu.is-open { opacity: 1; transform: translateY(0); pointer-events: auto; }

    .mh-scimenu .mh-sci-cta { display: grid; grid-template-columns: 1fr auto;
      align-items: center; gap: 14px; padding: 12px 18px; border-radius: 14px;
      background: #0b1f4d; color: #fff; text-decoration: none;
      transition: transform .18s ease, background .18s ease; }
    .mh-scimenu .mh-sci-cta:hover { transform: translateY(-1px); background: #11296a; }
    .mh-scimenu .mh-sci-cta .label { font-weight: 600; font-size: 15px; letter-spacing: .01em; }
    .mh-scimenu .mh-sci-cta .arr { font-size: 18px; opacity: .9; }

    .mh-scimenu .mh-sci-label { display: block; font-size: 10.5px; letter-spacing: .22em;
      text-transform: uppercase; color: rgba(8,18,40,.55); margin: 16px 6px 8px; font-weight: 600; }

    .mh-scimenu .mh-sci-list { display: flex; flex-direction: column; gap: 2px; }
    .mh-scimenu .mh-sci-pub { display: block;
      padding: 10px 12px; border-radius: 12px;
      text-decoration: none; color: #0b1f4d;
      transition: background .15s ease, transform .15s ease; }
    .mh-scimenu .mh-sci-pub:hover { background: rgba(11,31,77,.06); transform: translateX(2px); }
    .mh-scimenu .mh-sci-pub .meta { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
    .mh-scimenu .mh-sci-pub .tag { font-size: 10px; letter-spacing: .14em; text-transform: uppercase;
      color: rgba(8,18,40,.55); font-weight: 600; }
    .mh-scimenu .mh-sci-pub .ttl { font-size: 13.5px; line-height: 1.35; color: #0b1f4d;
      display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

    .mh-scimenu .mh-sci-foot { display: flex; justify-content: flex-end; padding: 10px 6px 2px; }
    .mh-scimenu .mh-sci-foot a { font-size: 12.5px; color: #0b1f4d; text-decoration: none;
      letter-spacing: .02em; font-weight: 600; opacity: .8; transition: opacity .15s ease; }
    .mh-scimenu .mh-sci-foot a:hover { opacity: 1; }

    @media (prefers-reduced-motion: reduce) {
      .mh-scimenu { transition: opacity .01s; transform: none !important; }
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  const menu = document.createElement('div');
  menu.className = 'mh-scimenu';
  menu.setAttribute('role', 'menu');
  menu.innerHTML = `
    <a class="mh-sci-cta" href="${window.mhLocalizePath('/pages/science#advisory-board')}">
      <span class="label">${(window.MH_MEGAMENU_LABELS && window.MH_MEGAMENU_LABELS.scienceAdvisoryBoard) || 'Science Advisory Board'}</span>
      <span class="arr">→</span>
    </a>
    <span class="mh-sci-label">${(window.MH_MEGAMENU_LABELS && window.MH_MEGAMENU_LABELS.scienceRecentPublications) || 'Recent publications'}</span>
    <div class="mh-sci-list">
      ${PUBS.map((p) => `
        <a class="mh-sci-pub" href="${p.href}">
          <span class="meta">
            ${p.tag ? `<span class="tag">${p.tag}</span>` : ''}
            <span class="ttl">${p.title}</span>
          </span>
        </a>`).join('')}
    </div>
    <div class="mh-sci-foot">
      <a href="${window.mhLocalizePath('/pages/publications')}">${(window.MH_MEGAMENU_LABELS && window.MH_MEGAMENU_LABELS.scienceViewAll) || 'View all publications →'}</a>
    </div>
  `;
  document.body.appendChild(menu);

  function position() {
    const r = sciLink.getBoundingClientRect();
    const m = menu.getBoundingClientRect();
    const top = Math.max(8, r.bottom + 32);
    let left = r.left + r.width / 2 - m.width / 2;
    left = Math.max(12, Math.min(left, window.innerWidth - m.width - 12));
    menu.style.top = top + 'px';
    menu.style.left = left + 'px';
  }

  let openT = null, closeT = null;
  const open  = () => { clearTimeout(closeT); openT = setTimeout(() => { position(); menu.classList.add('is-open'); }, 80); };
  const close = () => { clearTimeout(openT);  closeT = setTimeout(() => menu.classList.remove('is-open'), 180); };

  sciLink.addEventListener('mouseenter', open);
  sciLink.addEventListener('mouseleave', close);
  menu.addEventListener('mouseenter', () => clearTimeout(closeT));
  menu.addEventListener('mouseleave', close);
  window.addEventListener('scroll', () => menu.classList.contains('is-open') && position(), { passive: true });
  window.addEventListener('resize', () => menu.classList.contains('is-open') && position());
})();

/* ============================================================
   About mega menu — hover dropdown with shortcuts to the
   sub-sections of the about page (story, roadmap, advisors).
   ============================================================ */
(function () {
  if (window.__mhAboutMenuLoaded) return;
  window.__mhAboutMenuLoaded = true;

  // About hover menu removed per request — bail before building it.
  return;
  /* eslint-disable no-unreachable */
  const aboutLink = Array.from(document.querySelectorAll('header a, .nav a, .links a'))
    .find(a => {
      const text = (a.textContent || '').trim();
      const href = a.getAttribute('href') || '';
      return /^\s*about\s*$/i.test(text) || href.indexOf('/pages/about') !== -1;
    });
  if (!aboutLink) return;

  const ITEMS = [
    { tag: 'WHO WE ARE',       title: 'Company story',  desc: 'Our founder narrative and category POV.',     href: window.mhLocalizePath('/pages/company-story') },
    { tag: 'OUR EXPERTS',      title: 'Science advisory board', desc: 'The scientists behind the science.',          href: window.mhLocalizePath('/pages/science?view=about#advisory-board') }
  ];
  const PLACEHOLDERS = [
    'linear-gradient(135deg, #dfe7f5 0%, #6f8fc4 100%)',
    'linear-gradient(135deg, #e5edf7 0%, #5f7eb6 100%)'
  ];

  const css = `
    .mh-aboutmenu { position: fixed; z-index: 9999; min-width: 460px; max-width: 480px;
      padding: 14px; border-radius: 22px;
      background: rgba(255,255,255,.65);
      -webkit-backdrop-filter: saturate(1.6) blur(14px);
      backdrop-filter: saturate(1.6) blur(14px);
      border: 1.25px solid rgba(255,255,255,.55);
      box-shadow: 0 18px 48px rgba(8,18,40,.18), 0 2px 6px rgba(8,18,40,.08);
      opacity: 0; transform: translateY(-6px); pointer-events: none;
      transition: opacity .18s ease, transform .18s ease; }
    .mh-aboutmenu.is-open { opacity: 1; transform: translateY(0); pointer-events: auto; }

    .mh-aboutmenu .mh-about-label { display: block; font-size: 10.5px; letter-spacing: .22em;
      text-transform: uppercase; color: rgba(8,18,40,.55); margin: 0 6px 10px; font-weight: 600; }

    .mh-aboutmenu .mh-about-list { display: flex; flex-direction: column; gap: 2px; }
    .mh-aboutmenu .mh-about-item { display: grid; grid-template-columns: 48px 1fr;
      gap: 14px; padding: 10px 12px; border-radius: 12px;
      text-decoration: none; color: #0b1f4d; align-items: center;
      transition: background .15s ease, transform .15s ease; }
    .mh-aboutmenu .mh-about-item:hover { background: rgba(11,31,77,.06); transform: translateX(2px); }
    .mh-aboutmenu .mh-about-item .thumb { width: 48px; height: 48px; border-radius: 10px;
      background-size: cover; background-position: center; flex-shrink: 0; }
    .mh-aboutmenu .mh-about-item .meta { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
    .mh-aboutmenu .mh-about-item .tag { font-size: 10px; letter-spacing: .14em; text-transform: uppercase;
      color: rgba(8,18,40,.55); font-weight: 600; }
    .mh-aboutmenu .mh-about-item .ttl { font-size: 15px; font-weight: 600; color: #0b1f4d; line-height: 1.2; }
    .mh-aboutmenu .mh-about-item .desc { font-size: 12px; color: rgba(8,18,40,.65); line-height: 1.35; }

    .mh-aboutmenu .mh-about-foot { display: flex; justify-content: flex-end; padding: 10px 6px 2px; }
    .mh-aboutmenu .mh-about-foot a { font-size: 12.5px; color: #0b1f4d; text-decoration: none;
      letter-spacing: .02em; font-weight: 600; opacity: .8; transition: opacity .15s ease; }
    .mh-aboutmenu .mh-about-foot a:hover { opacity: 1; }

    @media (prefers-reduced-motion: reduce) {
      .mh-aboutmenu { transition: opacity .01s; transform: none !important; }
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  const menu = document.createElement('div');
  menu.className = 'mh-aboutmenu';
  menu.setAttribute('role', 'menu');
  menu.innerHTML = `
    <span class="mh-about-label">About Metabolica</span>
    <div class="mh-about-list">
      ${ITEMS.map((p, i) => `
        <a class="mh-about-item" href="${p.href}">
          <span class="thumb" style="background-image:${PLACEHOLDERS[i % PLACEHOLDERS.length]}"></span>
          <span class="meta">
            <span class="tag">${p.tag}</span>
            <span class="ttl">${p.title}</span>
            <span class="desc">${p.desc}</span>
          </span>
        </a>
      `).join('')}
    </div>
    <div class="mh-about-foot">
      <a href="${window.mhLocalizePath('/pages/about')}">Read the full story →</a>
    </div>
  `;
  document.body.appendChild(menu);

  function position() {
    const r = aboutLink.getBoundingClientRect();
    const m = menu.getBoundingClientRect();
    const top = Math.max(8, r.bottom + 32);
    let left = r.left + r.width / 2 - m.width / 2;
    left = Math.max(12, Math.min(left, window.innerWidth - m.width - 12));
    menu.style.top = top + 'px';
    menu.style.left = left + 'px';
  }

  let openT = null, closeT = null;
  const open  = () => { clearTimeout(closeT); openT = setTimeout(() => { position(); menu.classList.add('is-open'); }, 80); };
  const close = () => { clearTimeout(openT);  closeT = setTimeout(() => menu.classList.remove('is-open'), 180); };

  aboutLink.addEventListener('mouseenter', open);
  aboutLink.addEventListener('mouseleave', close);
  menu.addEventListener('mouseenter', () => clearTimeout(closeT));
  menu.addEventListener('mouseleave', close);
  window.addEventListener('scroll', () => menu.classList.contains('is-open') && position(), { passive: true });
  window.addEventListener('resize', () => menu.classList.contains('is-open') && position());
})();

/* ============================================================
   Discovery mega menu — hover dropdown listing the in-development
   research projects (PMT, Paracreasole, Acreos).
   ============================================================ */
(function () {
  if (window.__mhDiscMenuLoaded) return;
  window.__mhDiscMenuLoaded = true;

  const discLink = Array.from(document.querySelectorAll('header a, .nav a, .links a'))
    .find(a => {
      const text = (a.textContent || '').trim();
      const href = a.getAttribute('href') || '';
      return /^\s*discovery\s*$/i.test(text) || href.indexOf('/pages/acreos') !== -1;
    });
  if (!discLink) return;

  // EDIT THESE: project list shown in the dropdown. href can point to
  // an anchor on /pages/acreos (e.g. /pages/acreos#pmt) once those
  // sections have ids, or to a dedicated detail page.
  const PROJECTS = [
    { tag: 'GLP-1 REPLACEMENT', title: 'PMT',          desc: 'Peptide-modulating factor under study.', href: window.mhLocalizePath('/pages/acreos#pmt') },
    { tag: 'INVESTIGATIONAL',   title: 'Paracreasole', desc: 'Novel nutritional ingredient pipeline.',  href: window.mhLocalizePath('/pages/acreos#paracreasole') },
    { tag: 'PLATFORM',          title: 'Acreos',       desc: 'Next-generation postbiotic platform.',    href: window.mhLocalizePath('/pages/acreos') }
  ];
  const PLACEHOLDERS = [
    'linear-gradient(135deg, #f5b69a 0%, #c76d8e 100%)',
    'linear-gradient(135deg, #aab884 0%, #5a8a55 100%)',
    'linear-gradient(135deg, #c7b0de 0%, #5d3d7e 100%)'
  ];

  const css = `
    .mh-discmenu { position: fixed; z-index: 9999; min-width: 460px; max-width: 480px;
      padding: 14px; border-radius: 22px;
      background: rgba(255,255,255,.65);
      -webkit-backdrop-filter: saturate(1.6) blur(14px);
      backdrop-filter: saturate(1.6) blur(14px);
      border: 1.25px solid rgba(255,255,255,.55);
      box-shadow: 0 18px 48px rgba(8,18,40,.18), 0 2px 6px rgba(8,18,40,.08);
      opacity: 0; transform: translateY(-6px); pointer-events: none;
      transition: opacity .18s ease, transform .18s ease; }
    .mh-discmenu.is-open { opacity: 1; transform: translateY(0); pointer-events: auto; }

    .mh-discmenu .mh-disc-label { display: block; font-size: 10.5px; letter-spacing: .22em;
      text-transform: uppercase; color: rgba(8,18,40,.55); margin: 0 6px 10px; font-weight: 600; }

    .mh-discmenu .mh-disc-list { display: flex; flex-direction: column; gap: 2px; }
    .mh-discmenu .mh-disc-item { display: grid; grid-template-columns: 48px 1fr;
      gap: 14px; padding: 10px 12px; border-radius: 12px;
      text-decoration: none; color: #0b1f4d; align-items: center;
      transition: background .15s ease, transform .15s ease; }
    .mh-discmenu .mh-disc-item:hover { background: rgba(11,31,77,.06); transform: translateX(2px); }
    .mh-discmenu .mh-disc-item .thumb { width: 48px; height: 48px; border-radius: 10px;
      background-size: cover; background-position: center; flex-shrink: 0; }
    .mh-discmenu .mh-disc-item .meta { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
    .mh-discmenu .mh-disc-item .tag { font-size: 10px; letter-spacing: .14em; text-transform: uppercase;
      color: rgba(8,18,40,.55); font-weight: 600; }
    .mh-discmenu .mh-disc-item .ttl { font-size: 15px; font-weight: 600; color: #0b1f4d; line-height: 1.2; }
    .mh-discmenu .mh-disc-item .desc { font-size: 12px; color: rgba(8,18,40,.65); line-height: 1.35; }

    .mh-discmenu .mh-disc-foot { display: flex; justify-content: flex-end; padding: 10px 6px 2px; }
    .mh-discmenu .mh-disc-foot a { font-size: 12.5px; color: #0b1f4d; text-decoration: none;
      letter-spacing: .02em; font-weight: 600; opacity: .8; transition: opacity .15s ease; }
    .mh-discmenu .mh-disc-foot a:hover { opacity: 1; }

    @media (prefers-reduced-motion: reduce) {
      .mh-discmenu { transition: opacity .01s; transform: none !important; }
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  const menu = document.createElement('div');
  menu.className = 'mh-discmenu';
  menu.setAttribute('role', 'menu');
  menu.innerHTML = `
    <span class="mh-disc-label">In development</span>
    <div class="mh-disc-list">
      ${PROJECTS.map((p, i) => `
        <a class="mh-disc-item" href="${p.href}">
          <span class="thumb" style="background-image:${PLACEHOLDERS[i % PLACEHOLDERS.length]}"></span>
          <span class="meta">
            <span class="tag">${p.tag}</span>
            <span class="ttl">${p.title}</span>
            <span class="desc">${p.desc}</span>
          </span>
        </a>
      `).join('')}
    </div>
    <div class="mh-disc-foot">
      <a href="${window.mhLocalizePath('/pages/acreos')}">View the full pipeline →</a>
    </div>
  `;
  document.body.appendChild(menu);

  function position() {
    const r = discLink.getBoundingClientRect();
    const m = menu.getBoundingClientRect();
    const top = Math.max(8, r.bottom + 32);
    let left = r.left + r.width / 2 - m.width / 2;
    left = Math.max(12, Math.min(left, window.innerWidth - m.width - 12));
    menu.style.top = top + 'px';
    menu.style.left = left + 'px';
  }

  let openT = null, closeT = null;
  const open  = () => { clearTimeout(closeT); openT = setTimeout(() => { position(); menu.classList.add('is-open'); }, 80); };
  const close = () => { clearTimeout(openT);  closeT = setTimeout(() => menu.classList.remove('is-open'), 180); };

  discLink.addEventListener('mouseenter', open);
  discLink.addEventListener('mouseleave', close);
  menu.addEventListener('mouseenter', () => clearTimeout(closeT));
  menu.addEventListener('mouseleave', close);
  window.addEventListener('scroll', () => menu.classList.contains('is-open') && position(), { passive: true });
  window.addEventListener('resize', () => menu.classList.contains('is-open') && position());
})();

/* ============================================================
   Quiz mega menu — hover dropdown that previews the 60-second
   quiz with a mini-hero card (eyebrow + headline + topic chips
   + CTA). Same hover/positioning pattern as the other menus.
   ============================================================ */
(function () {
  if (window.__mhQuizMenuLoaded) return;
  window.__mhQuizMenuLoaded = true;

  const quizLink = Array.from(document.querySelectorAll('header a, .nav a, .links a'))
    .find(a => {
      const text = (a.textContent || '').trim();
      const href = a.getAttribute('href') || '';
      return /^\s*quiz\s*$/i.test(text) || href.indexOf('/pages/quiz') !== -1;
    });
  if (!quizLink) return;

  // EDIT THESE: copy that appears in the dropdown.
  const QUIZ = {
    eyebrow: 'YOUR RITUAL IN 60 SECONDS',
    headline: 'Find the precision probiotic built for the way you actually live.',
    chips: ['Sleep', 'Stress', 'Digestion', 'Energy'],
    cta: 'Take the 60-second quiz →',
    href: window.mhLocalizePath('/pages/quiz')
  };

  const css = `
    .mh-quizmenu { position: fixed; z-index: 9999; width: 460px; max-width: calc(100vw - 24px);
      padding: 22px 22px 20px; border-radius: 22px;
      background: rgba(255,255,255,.72);
      -webkit-backdrop-filter: saturate(1.6) blur(14px);
      backdrop-filter: saturate(1.6) blur(14px);
      border: 1.25px solid rgba(255,255,255,.6);
      box-shadow: 0 24px 60px -22px rgba(8,18,40,.30), 0 4px 12px rgba(8,18,40,.06);
      opacity: 0; transform: translateY(-6px); pointer-events: none;
      transition: opacity .2s ease, transform .2s ease;
      font-family: ui-sans-serif, system-ui, Arial, sans-serif; }
    .mh-quizmenu.is-open { opacity: 1; transform: translateY(0); pointer-events: auto; }

    .mh-quizmenu .mh-quiz-eyebrow {
      display: block; font-size: 11px; letter-spacing: .22em; text-transform: uppercase;
      color: rgba(8,18,40,.6); font-weight: 600; margin-bottom: 10px;
    }
    .mh-quizmenu .mh-quiz-headline {
      font-family: inherit; font-weight: 700; font-size: 22px; line-height: 1.22;
      letter-spacing: -0.018em; color: rgb(11,31,77); margin: 0 0 18px;
    }
    .mh-quizmenu .mh-quiz-chips {
      display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 18px;
    }
    .mh-quizmenu .mh-quiz-chip {
      display: inline-flex; align-items: center; padding: 6px 12px;
      border: 1px solid rgba(15,30,80,.18); border-radius: 999px;
      background: rgba(255,255,255,.85);
      font-size: 11px; font-weight: 600; letter-spacing: .12em;
      text-transform: uppercase; color: rgb(11,31,77);
    }
    .mh-quizmenu .mh-quiz-cta {
      display: inline-flex; align-items: center; justify-content: center; gap: 8px;
      padding: 14px 22px; border-radius: 999px;
      background: rgb(15,30,80); color: #fff;
      font-size: 14px; font-weight: 600; letter-spacing: .01em;
      text-decoration: none; width: 100%;
      box-shadow: 0 8px 24px -10px rgba(15,30,80,.45);
      transition: background .2s ease, transform .2s ease, box-shadow .2s ease;
    }
    .mh-quizmenu .mh-quiz-cta:hover {
      background: rgb(22,38,107);
      transform: translateY(-1px);
      box-shadow: 0 14px 32px -10px rgba(15,30,80,.55);
    }

    @media (prefers-reduced-motion: reduce) {
      .mh-quizmenu { transition: opacity .01s; transform: none !important; }
      .mh-quizmenu .mh-quiz-cta:hover { transform: none; }
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  const menu = document.createElement('div');
  menu.className = 'mh-quizmenu';
  menu.setAttribute('role', 'menu');
  menu.innerHTML = `
    <span class="mh-quiz-eyebrow">${QUIZ.eyebrow}</span>
    <h3 class="mh-quiz-headline">${QUIZ.headline}</h3>
    <div class="mh-quiz-chips">
      ${QUIZ.chips.map(c => `<span class="mh-quiz-chip">${c}</span>`).join('')}
    </div>
    <a class="mh-quiz-cta" href="${QUIZ.href}">${QUIZ.cta}</a>
  `;
  document.body.appendChild(menu);

  function position() {
    const r = quizLink.getBoundingClientRect();
    const m = menu.getBoundingClientRect();
    const top = Math.max(8, r.bottom + 32);
    let left = r.left + r.width / 2 - m.width / 2;
    left = Math.max(12, Math.min(left, window.innerWidth - m.width - 12));
    menu.style.top = top + 'px';
    menu.style.left = left + 'px';
  }

  let openT = null, closeT = null;
  const open  = () => { clearTimeout(closeT); openT = setTimeout(() => { position(); menu.classList.add('is-open'); }, 80); };
  const close = () => { clearTimeout(openT);  closeT = setTimeout(() => menu.classList.remove('is-open'), 180); };

  quizLink.addEventListener('mouseenter', open);
  quizLink.addEventListener('mouseleave', close);
  menu.addEventListener('mouseenter', () => clearTimeout(closeT));
  menu.addEventListener('mouseleave', close);
  window.addEventListener('scroll', () => menu.classList.contains('is-open') && position(), { passive: true });
  window.addEventListener('resize', () => menu.classList.contains('is-open') && position());
})();

/* ============================================================
   Science teaser — scroll-tied pill video playback.
   Maps video.currentTime to the section's progress through the
   viewport. Scrolling down advances the pill animation; scrolling
   up reverses it. Idempotent + reduced-motion aware.
   ============================================================ */
(() => {
  if (window.__mhPillScroll) return;
  const wrap = document.querySelector('.science-pill-anim[data-pill-scroll]');
  if (!wrap) return;
  const video = wrap.querySelector('video.science-pill-video');
  if (!video) return;
  window.__mhPillScroll = true;

  // Reduced motion: skip scroll-scrub, leave the poster/last frame visible.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  video.muted = true;
  video.playsInline = true;
  video.setAttribute('playsinline', '');
  video.preload = 'auto';
  video.pause();

  const section = wrap.closest('.science-teaser') || wrap;
  let duration = NaN;
  let raf = null;
  let lastTarget = -1;

  const onMeta = () => { duration = video.duration; schedule(); };
  if (video.readyState >= 1 && isFinite(video.duration)) onMeta();
  else video.addEventListener('loadedmetadata', onMeta);

  const update = () => {
    raf = null;
    if (!isFinite(duration) || duration <= 0) return;
    const r = section.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    // Progress 0 when section's top edge sits at viewport bottom;
    // progress 1 when section's bottom edge sits at viewport top.
    const total = r.height + vh;
    const passed = vh - r.top;
    const p = Math.max(0, Math.min(1, passed / total));
    const target = duration * p;
    // Skip micro-updates that wouldn't change a frame at ~30fps.
    if (Math.abs(target - lastTarget) < 0.03) return;
    lastTarget = target;
    try { video.currentTime = target; } catch (e) { /* iOS can throw mid-init */ }
  };
  const schedule = () => { if (raf == null) raf = requestAnimationFrame(update); };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
})();

/* ============================================================
   PDP strain carousel — prev/next arrows scroll the strain grid
   by one card width. No clone/loop, simple bounded scroll.
   ============================================================ */
(() => {
  if (window.__mhStrainCarousel) return;
  window.__mhStrainCarousel = true;
  document.querySelectorAll('.pdp-strain-carousel').forEach((carousel) => {
    const track = carousel.querySelector('.pdp-strain-grid');
    const prev = carousel.querySelector('.pdp-strain-carousel-prev');
    const next = carousel.querySelector('.pdp-strain-carousel-next');
    if (!track || !prev || !next) return;
    const cardStep = () => {
      const card = track.querySelector('.pdp-strain-card');
      if (!card) return 0;
      const cs = getComputedStyle(track);
      const gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -cardStep(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: cardStep(), behavior: 'smooth' }));
  });
})();

/* ============================================================
   Generic header hover-menu builder.
   Used by the Journal / Investor Hub / Contact menus below.
   Pattern matches the existing Science + About menus so all
   four nav popovers feel like one component family.
   ============================================================ */
(function () {
  if (window.__mhNavMenuShared) return;
  window.__mhNavMenuShared = true;

  // Shared base CSS for any nav popover. Each menu adds its own class.
  const css = `
    .mh-navmenu { position: fixed; z-index: 9999; min-width: 460px; max-width: 480px;
      padding: 14px; border-radius: 22px;
      background: rgba(255,255,255,.65);
      -webkit-backdrop-filter: saturate(1.6) blur(14px);
      backdrop-filter: saturate(1.6) blur(14px);
      border: 1.25px solid rgba(255,255,255,.55);
      box-shadow: 0 18px 48px rgba(8,18,40,.18), 0 2px 6px rgba(8,18,40,.08);
      opacity: 0; transform: translateY(-6px); pointer-events: none;
      transition: opacity .18s ease, transform .18s ease; }
    .mh-navmenu.is-open { opacity: 1; transform: translateY(0); pointer-events: auto; }

    .mh-navmenu .nm-label { display: block; font-size: 10.5px; letter-spacing: .22em;
      text-transform: uppercase; color: rgba(8,18,40,.55); margin: 0 6px 10px; font-weight: 600; }
    .mh-navmenu .nm-label.with-gap { margin-top: 16px; }

    .mh-navmenu .nm-cta { display: grid; grid-template-columns: 48px 1fr auto;
      align-items: center; gap: 14px; padding: 10px 16px 10px 10px; border-radius: 14px;
      background: #0b1f4d; color: #fff; text-decoration: none;
      transition: transform .18s ease, background .18s ease; }
    .mh-navmenu .nm-cta:hover { transform: translateY(-1px); background: #11296a; }
    .mh-navmenu .nm-cta .thumb { width: 48px; height: 48px; border-radius: 10px;
      background-size: cover; background-position: center; flex-shrink: 0; }
    .mh-navmenu .nm-cta .label { font-weight: 600; font-size: 15px; letter-spacing: .01em; }
    .mh-navmenu .nm-cta .arr { font-size: 18px; opacity: .9; }

    .mh-navmenu .nm-list { display: flex; flex-direction: column; gap: 2px; }
    .mh-navmenu .nm-item { display: flex; align-items: center; gap: 14px;
      padding: 10px 12px; border-radius: 12px;
      text-decoration: none; color: #0b1f4d;
      transition: background .15s ease, transform .15s ease; }
    .mh-navmenu .nm-item:hover { background: rgba(11,31,77,.06); transform: translateX(2px); }
    .mh-navmenu .nm-item .thumb { width: 56px; height: 56px; border-radius: 12px;
      object-fit: cover; flex-shrink: 0; background: rgba(11,31,77,.06); display: block; }
    .mh-navmenu .nm-item .meta { display: flex; flex-direction: column; gap: 3px; min-width: 0; flex: 1; }
    .mh-navmenu .nm-item .tag { font-size: 10px; letter-spacing: .14em; text-transform: uppercase;
      color: rgba(8,18,40,.55); font-weight: 600; }
    .mh-navmenu .nm-item .ttl { font-size: 14.5px; font-weight: 600; color: #0b1f4d;
      line-height: 1.25; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
    .mh-navmenu .nm-item .desc { font-size: 12px; color: rgba(8,18,40,.65); line-height: 1.35; }

    .mh-navmenu .nm-foot { display: flex; justify-content: flex-end; padding: 10px 6px 2px; }
    .mh-navmenu .nm-foot a { font-size: 12.5px; color: #0b1f4d; text-decoration: none;
      letter-spacing: .02em; font-weight: 600; opacity: .8; transition: opacity .15s ease; }
    .mh-navmenu .nm-foot a:hover { opacity: 1; }

    @media (prefers-reduced-motion: reduce) {
      .mh-navmenu { transition: opacity .01s; transform: none !important; }
    }
    /* Hide all nav popovers on touch / narrow viewports — the mobile
       drawer takes over there. */
    @media (max-width: 820px), (pointer: coarse) {
      .mh-navmenu { display: none !important; }
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  // Builder — call to register a hover menu for a given header link.
  //   matchText: case-insensitive text regex (e.g. /^journal$/i) — works on EN
  //   matchHref: optional URL fragment (e.g. '/pages/journal') so localized
  //              labels (Journal → Le Journal) still attach the menu
  //   build(menu, link) — render the menu HTML
  window.__mhBuildNavMenu = function (matchText, build, matchHref) {
    const link = Array.from(document.querySelectorAll('header a, .nav a, .nav .links a'))
      .find(a => {
        const t = (a.textContent || '').trim();
        if (matchText && matchText.test(t)) return true;
        if (matchHref) {
          const h = a.getAttribute('href') || '';
          if (h.indexOf(matchHref) !== -1) return true;
        }
        return false;
      });
    if (!link) return;

    const menu = document.createElement('div');
    menu.className = 'mh-navmenu';
    menu.setAttribute('role', 'menu');
    menu.innerHTML = build();
    document.body.appendChild(menu);

    function position() {
      const r = link.getBoundingClientRect();
      const m = menu.getBoundingClientRect();
      const top = Math.max(8, r.bottom + 32);
      let left = r.left + r.width / 2 - m.width / 2;
      left = Math.max(12, Math.min(left, window.innerWidth - m.width - 12));
      menu.style.top = top + 'px';
      menu.style.left = left + 'px';
    }

    let openT = null, closeT = null;
    const open  = () => { clearTimeout(closeT); openT = setTimeout(() => { position(); menu.classList.add('is-open'); }, 80); };
    const close = () => { clearTimeout(openT);  closeT = setTimeout(() => menu.classList.remove('is-open'), 180); };

    link.addEventListener('mouseenter', open);
    link.addEventListener('mouseleave', close);
    menu.addEventListener('mouseenter', () => clearTimeout(closeT));
    menu.addEventListener('mouseleave', close);
    window.addEventListener('scroll', () => menu.classList.contains('is-open') && position(), { passive: true });
    window.addEventListener('resize', () => menu.classList.contains('is-open') && position());
  };
})();

/* ============================================================
   Journal nav popover — recent journal entries
   ============================================================ */
(function () {
  if (window.__mhJournalMenuLoaded) return;
  window.__mhJournalMenuLoaded = true;
  if (typeof window.__mhBuildNavMenu !== 'function') return;

  // Pull first 3 journal entries from window.MH_RECENT_JOURNAL (rendered by
  // layout/theme.liquid). Fall back to a single "View all entries" item.
  const ENTRIES = (Array.isArray(window.MH_RECENT_JOURNAL) && window.MH_RECENT_JOURNAL.length)
    ? window.MH_RECENT_JOURNAL.slice(0, 3)
    : [{ tag: '', title: 'View all entries', href: window.mhLocalizePath('/pages/journal') }];

  const _JLABEL    = (window.MH_MEGAMENU_LABELS && window.MH_MEGAMENU_LABELS.journalLabel)   || 'Recent entries';
  const _JVIEW_ALL = (window.MH_MEGAMENU_LABELS && window.MH_MEGAMENU_LABELS.journalViewAll) || 'View all entries →';
  window.__mhBuildNavMenu(/^\s*journal\s*$/i, () => `
    <span class="nm-label">${_JLABEL}</span>
    <div class="nm-list">
      ${ENTRIES.map((e) => `
        <a class="nm-item" href="${e.href}">
          ${e.img ? `<img class="thumb" src="${e.img}" alt="" loading="lazy" />` : '<span class="thumb"></span>'}
          <span class="meta">
            ${e.tag ? `<span class="tag">${e.tag}</span>` : ''}
            <span class="ttl">${e.title}</span>
          </span>
        </a>
      `).join('')}
    </div>
    <div class="nm-foot">
      <a href="${window.mhLocalizePath('/pages/journal')}">${_JVIEW_ALL}</a>
    </div>
  `, '/pages/journal');
})();


